import { render, staticRenderFns } from "./EcomFilterCategory.vue?vue&type=template&id=036eb054&scoped=true"
import script from "./EcomFilterCategory.vue?vue&type=script&lang=js"
export * from "./EcomFilterCategory.vue?vue&type=script&lang=js"
import style0 from "./EcomFilterCategory.vue?vue&type=style&index=0&id=036eb054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036eb054",
  null
  
)

export default component.exports